import { createIrisApiClient, basePaths } from 'API/clients/iris/irisapi'
import { filterParamSerializer } from 'API/utilities/filterParamSerializer'

const irisApiClient = createIrisApiClient(basePaths.iris)
const aircraftsPath = 'aircrafts'

const getAirCraftsFiltered = (params?) => {
  return irisApiClient.get(`/${aircraftsPath}/`, {
    params,
    paramsSerializer: filterParamSerializer,
  })
}

export { getAirCraftsFiltered }
